import { c as _c } from "react/compiler-runtime";
import { MouseEvent, PointerEvent, useRef } from "react";
const DRAG_START_THRESHOLD = 6;
const DRAG_CLICK_SUPPRESSION_WINDOW = 100;
type DragState = {
  hasDragged: boolean;
  pointerId: number;
  startScrollLeft: number;
  startX: number;
};
export const useHorizontalDragScroll = () => {
  const $ = _c(6);
  const dragStateReference = useRef(undefined);
  const lastDragEndTimeReference = useRef(Number.NEGATIVE_INFINITY);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = event => {
      if (event.pointerType !== "mouse" || event.button !== 0) {
        return;
      }
      if (event.target instanceof Element && event.target.closest("input, textarea, select, [contenteditable=true]")) {
        return;
      }
      dragStateReference.current = {
        hasDragged: false,
        pointerId: event.pointerId,
        startScrollLeft: event.currentTarget.scrollLeft,
        startX: event.clientX
      };
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handlePointerDown = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event_0 => {
      const dragState = dragStateReference.current;
      if (!dragState || dragState.pointerId !== event_0.pointerId) {
        return;
      }
      const distance = event_0.clientX - dragState.startX;
      if (!dragState.hasDragged) {
        if (Math.abs(distance) < DRAG_START_THRESHOLD) {
          return;
        }
        dragState.hasDragged = true;
        event_0.currentTarget.setPointerCapture(event_0.pointerId);
      }
      event_0.preventDefault();
      event_0.currentTarget.scrollLeft = dragState.startScrollLeft - distance;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePointerMove = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (event_1, suppressClick) => {
      const dragState_0 = dragStateReference.current;
      if (!dragState_0 || dragState_0.pointerId !== event_1.pointerId) {
        return;
      }
      if (suppressClick && dragState_0.hasDragged) {
        lastDragEndTimeReference.current = event_1.timeStamp;
      }
      if (event_1.currentTarget.hasPointerCapture(event_1.pointerId)) {
        event_1.currentTarget.releasePointerCapture(event_1.pointerId);
      }
      dragStateReference.current = undefined;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const finishDragging = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event_2 => {
      const happenedImmediatelyAfterDrag = event_2.timeStamp - lastDragEndTimeReference.current < DRAG_CLICK_SUPPRESSION_WINDOW;
      if (!happenedImmediatelyAfterDrag) {
        return;
      }
      event_2.preventDefault();
      event_2.stopPropagation();
      lastDragEndTimeReference.current = Number.NEGATIVE_INFINITY;
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClickCapture = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event_3 => finishDragging(event_3, false);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      onClickCapture: handleClickCapture,
      onPointerCancel: t4,
      onPointerDown: handlePointerDown,
      onPointerMove: handlePointerMove,
      onPointerUp: event_4 => finishDragging(event_4, true)
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};